export default function getStripePaymentPortalHref() {
  return (
    window.location.origin +
    "/payment/portal?return_to=" +
    encodeURIComponent(window.location.href)
  )
}
